import { PointerEvent } from 'react';
import { useSapphireMedia } from '../../hooks/useSapphireMedia';
import {
  calculateDasharray,
  calculateRotation,
  DONUT_CENTER,
  DONUT_RADIUS,
} from './utils/donut';

type Props = {
  percentage: number;
  segmentGap: number;
  color?: string;
  isFirst?: boolean;
  offset?: number;
  strokeWidth?: number;
  dimmed?: boolean;
  onPointerEnter?: (e: PointerEvent) => void;
  onPointerLeave?: (e: PointerEvent) => void;
};

export function DonutSegment({
  percentage,
  segmentGap,
  offset = 0,
  color,
  isFirst = false,
  strokeWidth = 2.6,
  dimmed = false,
  onPointerEnter,
  onPointerLeave,
}: Props) {
  const { isExtraSmall, isSmall } = useSapphireMedia();

  const rotate = calculateRotation(offset, isFirst);
  const dasharray = calculateDasharray(percentage, segmentGap);

  const HIT_AREA_STROKE_WIDTH = isExtraSmall || isSmall ? 5 : 12;

  return (
    <g>
      {onPointerEnter && (
        <circle
          cx={DONUT_CENTER}
          cy={DONUT_CENTER}
          r={DONUT_RADIUS}
          fill={'transparent'}
          stroke={'transparent'}
          strokeWidth={HIT_AREA_STROKE_WIDTH}
          strokeDasharray={dasharray}
          transform={rotate}
          onPointerEnter={onPointerEnter}
          onPointerLeave={onPointerLeave}
          style={{ cursor: 'pointer', pointerEvents: 'stroke' }}
        />
      )}
      <circle
        className={'donut-segment'}
        data-per={percentage}
        cx={DONUT_CENTER}
        cy={DONUT_CENTER}
        r={DONUT_RADIUS}
        fill={'transparent'}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray={dasharray}
        transform={rotate}
        style={{
          opacity: dimmed ? 0.35 : 1,
          transition: 'opacity 0.2s ease',
          pointerEvents: 'none',
        }}
      />
    </g>
  );
}
